export enum RequestAccessApiErrorKey {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
}

export const requestAccessApiErrors: Record<string, string> = {
  [RequestAccessApiErrorKey.ALREADY_EXISTS]: 'alreadyExists',
};
